const dataSource = [
    {
        prenum: '20',
        zh: '埃及',
        py: 'A'
    },
    {
        prenum: '251',
        zh: '埃塞俄比亚',
        py: 'A'
    },
    {
        prenum: '358',
        zh: '奥兰群岛',
        py: 'A'
    },
    {
        prenum: '43',
        zh: '奥地利',
        py: 'A'
    },
    {
        prenum: '244',
        zh: '安哥拉',
        py: 'A'
    },
    {
        prenum: '975',
        zh: '不丹',
        py: 'B'
    },
    {
        prenum: '501',
        zh: '伯利兹',
        py: 'B'
    },
    {
        prenum: '359',
        zh: '保加利亚',
        py: 'B'
    },
    {
        prenum: '354',
        zh: '冰岛',
        py: 'B'
    },
    {
        prenum: '1',
        zh: '北马里亚纳群岛',
        py: 'B'
    },
    {
        prenum: '850',
        zh: '朝鲜',
        py: 'C'
    },
    {
        prenum: '240',
        zh: '赤道几内亚',
        py: 'C'
    },
    {
        prenum: '670',
        zh: '东帝汶',
        py: 'D'
    },
    {
        prenum: '45',
        zh: '丹麦',
        py: 'D'
    },
    {
        prenum: '228',
        zh: '多哥',
        py: 'D'
    },
    {
        prenum: '1',
        zh: '多米尼克',
        py: 'D'
    },
    {
        prenum: '49',
        zh: '德国',
        py: 'D'
    },
    {
        prenum: '7',
        zh: '俄罗斯',
        py: 'E'
    },
    {
        prenum: '593',
        zh: '厄瓜多尔',
        py: 'E'
    },
    {
        prenum: '291',
        zh: '厄立特里亚',
        py: 'E'
    },
    {
        prenum: '238',
        zh: '佛得角',
        py: 'F'
    },
    {
        prenum: '679',
        zh: '斐济',
        py: 'F'
    },
    {
        prenum: '379',
        zh: '梵蒂冈',
        py: 'F'
    },
    {
        prenum: '33',
        zh: '法国',
        py: 'F'
    },
    {
        prenum: '590',
        zh: '法属圣马丁',
        py: 'F'
    },
    {
        prenum: '1',
        zh: '关岛',
        py: 'G'
    },
    {
        prenum: '220',
        zh: '冈比亚',
        py: 'G'
    },
    {
        prenum: '242',
        zh: '刚果（布）',
        py: 'G'
    },
    {
        prenum: '243',
        zh: '刚果（金）',
        py: 'G'
    },
    {
        prenum: '53',
        zh: '古巴',
        py: 'G'
    },
    {
        prenum: '7',
        zh: '哈萨克斯坦',
        py: 'H'
    },
    {
        prenum: '504',
        zh: '洪都拉斯',
        py: 'H'
    },
    {
        prenum: '509',
        zh: '海地',
        py: 'H'
    },
    {
        prenum: '31',
        zh: '荷兰',
        py: 'H'
    },
    {
        prenum: '599',
        zh: '荷兰加勒比',
        py: 'H'
    },
    {
        prenum: '224',
        zh: '几内亚',
        py: 'J'
    },
    {
        prenum: '245',
        zh: '几内亚比绍',
        py: 'J'
    },
    {
        prenum: '1',
        zh: '加拿大',
        py: 'J'
    },
    {
        prenum: '233',
        zh: '加纳',
        py: 'J'
    },
    {
        prenum: '241',
        zh: '加蓬',
        py: 'J'
    },
    {
        prenum: '385',
        zh: '克罗地亚',
        py: 'K'
    },
    {
        prenum: '974',
        zh: '卡塔尔',
        py: 'K'
    },
    {
        prenum: '237',
        zh: '喀麦隆',
        py: 'K'
    },
    {
        prenum: '682',
        zh: '库克群岛',
        py: 'K'
    },
    {
        prenum: '599',
        zh: '库拉索',
        py: 'K'
    },
    {
        prenum: '423',
        zh: '列支敦士登',
        py: 'L'
    },
    {
        prenum: '218',
        zh: '利比亚',
        py: 'L'
    },
    {
        prenum: '231',
        zh: '利比里亚',
        py: 'L'
    },
    {
        prenum: '250',
        zh: '卢旺达',
        py: 'L'
    },
    {
        prenum: '352',
        zh: '卢森堡',
        py: 'L'
    },
    {
        prenum: '52',
        zh: '墨西哥',
        py: 'M'
    },
    {
        prenum: '880',
        zh: '孟加拉国',
        py: 'M'
    },
    {
        prenum: '691',
        zh: '密克罗尼西亚联邦',
        py: 'M'
    },
    {
        prenum: '373',
        zh: '摩尔多瓦',
        py: 'M'
    },
    {
        prenum: '212',
        zh: '摩洛哥',
        py: 'M'
    },
    {
        prenum: '211',
        zh: '南苏丹',
        py: 'N'
    },
    {
        prenum: '27',
        zh: '南非',
        py: 'N'
    },
    {
        prenum: '505',
        zh: '尼加拉瓜',
        py: 'N'
    },
    {
        prenum: '234',
        zh: '尼日利亚',
        py: 'N'
    },
    {
        prenum: '227',
        zh: '尼日尔',
        py: 'N'
    },
    {
        prenum: '680',
        zh: '帕劳',
        py: 'P'
    },
    {
        prenum: '48',
        zh: '波兰',
        py: 'P'
    },
    {
        prenum: '351',
        zh: '葡萄牙',
        py: 'P'
    },
    {
        prenum: '81',
        zh: '日本',
        py: 'R'
    },
    {
        prenum: '46',
        zh: '瑞典',
        py: 'R'
    },
    {
        prenum: '41',
        zh: '瑞士',
        py: 'R'
    },
    {
        prenum: '1',
        zh: '圣卢西亚',
        py: 'S'
    },
    {
        prenum: '1',
        zh: '圣基茨和尼维斯',
        py: 'S'
    },
    {
        prenum: '239',
        zh: '圣多美和普林西比',
        py: 'S'
    },
    {
        prenum: '590',
        zh: '圣巴泰勒米',
        py: 'S'
    },
    {
        prenum: '1',
        zh: '圣文森特和格林纳丁斯',
        py: 'S'
    },
    {
        prenum: '508',
        zh: '圣皮埃尔和密克隆群岛',
        py: 'S'
    },
    {
        prenum: '688',
        zh: '图瓦卢',
        py: 'T'
    },
    {
        prenum: '993',
        zh: '土库曼斯坦',
        py: 'T'
    },
    {
        prenum: '90',
        zh: '土耳其',
        py: 'T'
    },
    {
        prenum: '255',
        zh: '坦桑尼亚',
        py: 'T'
    },
    {
        prenum: '992',
        zh: '塔吉克斯坦',
        py: 'T'
    },
    {
        prenum: '58',
        zh: '委内瑞拉',
        py: 'V'
    },
    {
        prenum: '380',
        zh: '乌克兰',
        py: 'W'
    },
    {
        prenum: '998',
        zh: '乌兹别克斯坦',
        py: 'W'
    },
    {
        prenum: '256',
        zh: '乌干达',
        py: 'W'
    },
    {
        prenum: '598',
        zh: '乌拉圭',
        py: 'W'
    },
    {
        prenum: '502',
        zh: '危地马拉',
        py: 'W'
    },
    {
        prenum: '36',
        zh: '匈牙利',
        py: 'X'
    },
    {
        prenum: '963',
        zh: '叙利亚',
        py: 'X'
    },
    {
        prenum: '30',
        zh: '希腊',
        py: 'X'
    },
    {
        prenum: '65',
        zh: '新加坡',
        py: 'X'
    },
    {
        prenum: '687',
        zh: '新喀里多尼亚',
        py: 'X'
    },
    {
        prenum: '967',
        zh: '也门',
        py: 'Y'
    },
    {
        prenum: '374',
        zh: '亚美尼亚',
        py: 'Y'
    },
    {
        prenum: '972',
        zh: '以色列',
        py: 'Y'
    },
    {
        prenum: '964',
        zh: '伊拉克',
        py: 'Y'
    },
    {
        prenum: '98',
        zh: '伊朗',
        py: 'Y'
    },
    {
        prenum: '86',
        zh: '中国',
        py: 'Z'
    },
    {
        prenum: '236',
        zh: '中非共和国',
        py: 'Z'
    },
    {
        prenum: '886',
        zh: '中国台湾',
        py: 'Z'
    },
    {
        prenum: '853',
        zh: '中国澳门',
        py: 'Z'
    },
    {
        prenum: '852',
        zh: '中国香港',
        py: 'Z'
    }
];

const hotData = [
    {
        prenum: '86',
        py: 'rm',
        zh: '中国',
        text: '中国',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '1',
        py: 'rm',
        zh: '加拿大',
        text: '加拿大',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '886',
        py: 'rm',
        zh: '中国台湾',
        text: '中国台湾',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '49',
        py: 'rm',
        zh: '德国',
        text: '德国',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '39',
        py: 'rm',
        zh: '意大利',
        text: '意大利',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '65',
        py: 'rm',
        zh: '新加坡',
        text: '新加坡',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '64',
        py: 'rm',
        zh: '新西兰',
        text: '新西兰',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '81',
        py: 'rm',
        zh: '日本',
        text: '日本',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '33',
        py: 'rm',
        zh: '法国',
        text: '法国',
        indexText: '热门',
        title: '热门国家或地区'
    },
    {
        prenum: '66',
        py: 'rm',
        zh: '泰国',
        text: '泰国',
        indexText: '热门',
        title: '热门国家或地区'
    }
];

const listSource: { [propName: string]: ListSourceItemModel[] } = { 热门国家或地区: hotData };
dataSource.forEach((item) => {
    if (listSource[item.py]) {
        listSource[item.py].push(item);
    } else {
        listSource[item.py] = [item];
    }
});

export interface ListSourceItemModel {
    prenum: string;
    py: string;
    zh: string;
    text?: string;
    indexText?: string;
    title?: string;
}
export { dataSource, hotData, listSource };
